<script setup lang="ts">
// Miolo repetido do RewardCard.vue (prazo + ação de resgate/status),
// extraído porque o card tinha esse bloco duplicado byte a byte entre a
// versão desktop e a mobile. Continuam duas instâncias no template do pai
// (uma por v-if isMobile/!isMobile) de propósito — WidgetsCountdown roda um
// setInterval, então só uma pode estar montada por vez; aqui só elimina a
// duplicação de markup, não o v-if em si.
type Props = {
  redeemable: boolean;
  countDownTotalTime: number;
  isExpired: boolean;
  status: { text: string; color: string; bg: string; border: string };
  updatedAt?: string;
};

defineProps<Props>();

const emit = defineEmits<{ 'timer-finished': []; redeem: [] }>();

const { getDateTime } = useDateTimeHelper();
</script>

<template>
  <div
    v-if="redeemable && countDownTotalTime && !isExpired"
    class="flex h-[36px] shrink-0 flex-col items-center justify-center whitespace-nowrap rounded-[8px] bg-white/5 px-[10px] py-[4px] text-center"
  >
    <span class="-mb-[2px] text-[9px] leading-none text-white/50">
      Expira em:
    </span>
    <WidgetsCountdown
      :total-time="countDownTotalTime"
      @timer-finished="emit('timer-finished')"
    >
      <template #process="{ time }">
        <span class="text-[11px] leading-none tabular-nums text-white">
          {{ `${time.hours}h:${time.minutes}m:${time.seconds}s` }}
        </span>
      </template>
      <template #finish>
        <span class="text-[11px] leading-none text-white">
          {{ $t('rewards.expired') }}
        </span>
      </template>
    </WidgetsCountdown>
  </div>
  <div
    v-else-if="redeemable"
    class="flex h-[36px] shrink-0 items-center justify-center whitespace-nowrap rounded-[8px] bg-white/5 px-[10px] py-[4px] text-center text-[11px] text-white"
  >
    {{ $t('rewards.expired') }}
  </div>

  <UserV2RewardRedeemButton
    v-if="redeemable"
    :disabled="isExpired"
    @redeem="emit('redeem')"
  />
  <div
    v-else
    class="flex h-[36px] shrink-0 flex-col items-center justify-center gap-[2px] rounded-[11px] border border-solid px-[10px] py-[4px] text-center"
    :class="[status.color, status.bg, status.border]"
  >
    <span class="whitespace-nowrap text-[11px] font-semibold">
      {{ status.text }}
    </span>
    <span
      v-if="updatedAt"
      class="whitespace-nowrap text-[10px] opacity-70"
    >
      {{ getDateTime(updatedAt) }}
    </span>
  </div>
</template>
